import React from 'react';
import { ActionPopup, BodyTemplate, ButtonComponent, CardWithTabs, Icon, TextButton, PaymentHistoryTable, EntireLoader } from 'renderer/components';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { useWindowSize } from 'renderer/utils';
import { StoreQuery } from 'renderer/queries';
import { useRecoilState } from 'recoil';
import { Atoms } from 'renderer/stores';
var SalesList = function (props) {
    var store = StoreQuery.getMyStoreInCache();
    var storeId = store === null || store === void 0 ? void 0 : store.id;
    var _a = useRecoilState(Atoms.salesModalState), setSalesDrawer = _a[1];
    var _b = useWindowSize(), isPC = _b.isPC, height = _b.height;
    var handleOpen = function (data) {
        setSalesDrawer({
            salesHistory: data
        });
    };
    return storeId ? (React.createElement(BodyTemplate, { title: "\uB9E4\uCD9C \uB4F1\uB85D/\uBAA9\uB85D", extra: React.createElement(RegisterButtons, { isPC: isPC, onClick: function (type) { return handleOpen({ type: type }); } }), content: React.createElement(SalesTab, { height: height, storeId: storeId }) })) : (React.createElement(EntireLoader, { open: true }));
};
var getColumnKeys = function (type) {
    switch (type) {
        case 'all':
            return [
                'paidAt',
                'type',
                'location',
                'manager',
                'customerName',
                'ticket',
                'totalPrice',
                'deduction',
                'methods',
                'paidPrice',
                'createCustomerPoint',
                'memo'
                // 'management',
                // 'details',
                // 'qr'
            ];
    }
};
var SalesTab = function (props) {
    var tabs = [{ tab: '전체 매출내역', key: 'all' }];
    return (React.createElement(CardWithTabs, { tabList: tabs, defaultActiveTabKey: "all", children: {
            all: (React.createElement(PaymentHistoryTable, { tableId: "ALL_PAYMENT_TABLE", availableColumnSettings: true, params: { storeId: props.storeId }, columns: getColumnKeys('all') }))
        } }));
};
var RegisterButtons = function (props) {
    return props.isPC ? (React.createElement(Row, { gutter: 8, style: { marginTop: '5px' } },
        React.createElement(Col, null,
            React.createElement(ButtonComponent, { children: "\uC120\uBD88\uC561\u2219\uC815\uAE30\uAD8C \uD310\uB9E4", onClick: function () {
                    props.onClick('ticket');
                } })),
        React.createElement(Col, null,
            React.createElement(ButtonComponent, { children: "\uC0C1\uD488 \uD310\uB9E4", onClick: function () {
                    props.onClick('product');
                } })))) : (React.createElement(ActionPopup, { trigger: React.createElement(TextButton, { children: "\uB9E4\uCD9C\uB4F1\uB85D", icon: React.createElement(Icon, { name: "plus" }) }), actions: [
            {
                label: '선불액∙정기권 판매',
                onClick: function () { return props.onClick('ticket'); }
            },
            { label: '상품 판매', onClick: function () { return props.onClick('product'); } }
        ] }));
};
export default SalesList;
